export default __webpack_public_path__ + "static/backgroundBanner-f13a00642f00c153912e6a518902bcdf.png";